import { useAppSelector } from '../../../app/hooks'

export default function useSignInState() {
  const signInState = useAppSelector((state) => state.user.status)
  return signInState
}
